import React, { useMemo, useState } from "react";
import { StaticMap, Image } from "artisn-ui-react";
import { Store } from "artisn/types";

import Styles, { ModalStyled } from "./ProfileStores.styles";
import { ProfileStoresProps as Props } from "./ProfileStores.types";
import Navbar from "components/global/Navbar/Navbar";
import ProfileNavigation from "components/global/ProfileNavigation/ProfileNavigation";
import Footer from "components/global/Footer/Footer";
import { getENVs } from "config/artisn.config";
import StoreList from "components/chooseStore/StoreList/StoreList";
import { useFetchStores } from "services/stores/stores.service.hooks";
import useStores from "contexts/stores/stores.context.hooks";
import { nextOpeningHourHelper } from "components/global/StorePreview/StorePreview.helpers";
import useCatalogues from "contexts/catalogues/catalogues.hooks";
import { isTouchScreenDevice } from "utils/common.utils";
import { getMaxWidth } from "utils/styling.utils";
import ProfileHeader from "components/profile/ProfileHeader/ProfileHeader";
import GoBack from "components/global/GoBack/GoBack";

import AddressSVG from "../../../../public/assets/images/address.svg";
import PhoneSVG from "../../../../public/assets/images/phone.svg";
import TimeSVG from "../../../../public/assets/images/time.svg";
import CloseSVG from "../../../../public/assets/images/close.svg";

const ProfileStores: React.FC<Props> = props => {
  const { data: stores, isLoading, isError } = useFetchStores();
  const { setSelectedStore, selectedStore } = useStores();
  const { schedules, phone, storeName, isOpen, images } = selectedStore ?? {};
  const { address } = selectedStore ?? {};
  const [mapStore, setMapStore] = useState<Store | undefined>(selectedStore);
  const { latitude: lat, longitude: lng } = mapStore ?? {};
  const { selectedCatalogueId } = useCatalogues();
  const isTouchDevice = typeof isTouchScreenDevice() === "boolean";
  const [opened, setOpened] = useState(false);
  const maxWidth = +getMaxWidth().replace("px", "");

  const onSelectedStore = (store: Store) => {
    setSelectedStore(store);
    setMapStore(store);
    if (isTouchDevice) {
      setOpened(true);
    }
  };

  const nextOpeningHour = useMemo(() => {
    if (!schedules) return;
    return nextOpeningHourHelper(schedules, +selectedCatalogueId);
  }, [selectedCatalogueId, schedules]);

  const storeInfoNode = (
    <div className="ProfileStores__info">
      {images?.length ? (
        <Image
          className="ProfileStores__image"
          image={images[0]}
          alt={storeName ?? ""}
          config={{
            width: 240,
            height: 240
          }}
        />
      ) : null}
      <div className="ProfileStores__opened">
        {isOpen ? (
          <div className="ProfileStores__point ProfileStores__point--active" />
        ) : (
          <div className="ProfileStores__point" />
        )}
        {isOpen ? "Abierto" : "Cerrado"}
      </div>
      <div className="ProfileStores__location">
        <div>
          <AddressSVG />
          Dirección:
        </div>
        <p className="ProfileStores__text" title={address}>
          {address}
        </p>
      </div>
      <div className="ProfileStores__phone">
        <PhoneSVG />
        Teléfono:
        <p className="ProfileStores__text" title={phone}>
          {phone}
        </p>
      </div>
      <div className="ProfileStores__time">
        <TimeSVG />
        Abre:
        <p className="ProfileStores__text" title={nextOpeningHour}>
          {nextOpeningHour}
        </p>
      </div>
    </div>
  );

  return (
    <Styles className="ProfileStores">
      <header className="ProfileStores__header">
        <Navbar className="ProfileStores__navbar" />
        <ProfileHeader className="ProfileBilling__profile-header" />
      </header>
      <main className="ProfileStores__main">
        <ProfileNavigation className="ProfileStores__profile-navigation" />
        <div className="ProfileStores__wrapper">
          <GoBack className="ProfileStores__go-back" />
          <h2 className="ProfileStores__title">Locales</h2>
          <div className="ProfileStores__map">
            {/* TODO: create an account on cloudinary to upload map icons */}
            {selectedStore ? (
              <StaticMap
                googleMapsKey={`${getENVs?.mapsApiKey}`}
                width={isTouchDevice ? maxWidth - 32 : 550}
                height={310}
                className="ProfileStores__static-map"
                markers={[
                  {
                    coordinates: {
                      lat: lat!,
                      lng: lng!
                    },
                    icon: "https://res.cloudinary.com/dphyzfzpu/image/upload/v1661372561/Hornero-prod/icon_store_umzxzu_kpufeo.png"
                  }
                ]}
              />
            ) : null}
          </div>
          <div className="ProfileStores__bottom">
            <div className="ProfileStores__list">
              <StoreList
                className="ProfileStores__stores"
                stores={stores}
                isLoading={isLoading}
                isError={isError}
                selectedStore={mapStore}
                onStoreClick={onSelectedStore}
              />
            </div>
            {!isTouchDevice && selectedStore ? storeInfoNode : null}
          </div>
        </div>
      </main>
      <ModalStyled
        className="ModalInfoLocal"
        opened={isTouchDevice && opened}
        closeIcon={<CloseSVG />}
        onClose={() => setOpened(false)}
      >
        {selectedStore ? storeInfoNode : null}
      </ModalStyled>
      <footer className="ProfileStores__footer">
        <Footer />
      </footer>
    </Styles>
  );
};

ProfileStores.defaultProps = {};

export default ProfileStores;
